import Service from '@/services/Service'

class RegionService extends Service {
  constructor() {
    super('REGION')
    this.resource = 'mbcommerce/region'
  }

  async getRegionTax(query) {
    let requestUrl = `${this.resource}/price`
    requestUrl = this.createRequestUrl(query, requestUrl)
    console.log(requestUrl)
    let response = await this.getAPI(requestUrl)
    console.log(requestUrl, response)
    return response
  }
}

export default new RegionService()
